export default __webpack_public_path__ + "static/media/1.38a3ff9d.svg";